export const LISTE_FACE_COMPTE_ANALYTIQUE = {
  title: 'Liste des comptes analytiques',
  breadcrumb: {
    liste: 'Liste comptes analytiques',
  },
  actions: {
    add: 'Ajouter un compte analytique',
  },
  tab: {
    compteAnalytique: 'Compte analytique',
    actif: 'Actif',
    nbProduit: 'Nb produits',
  },
  filtres: {
    actif: {
      tilte: 'Actif',
      yes: 'Oui',
      no: 'Non',
    },
  },
  messages: {
    success: {
      delete: 'Compte analytique supprimé avec succès.',
      archiver: 'Compte analytique archivé avec succès.',
      desarchiver: 'Compte analytique désarchivé avec succès.',
    },
    error: {
      produitLieCompteAnalytique: 'Impossible de supprimer un compte analytique lié à un produit.',
    },
  },
  popUpArchivage: {
    titleArchiver: 'Etes-vous sûr de vouloir archiver ce compte analytique ?',
    titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce compte analytique ?',
  },
  popUpDelete: {
    title: 'Etes-vous sûr de vouloir supprimer ce compte analytique ?',
  },
};

export const ADD_FACE_COMPTE_ANALYTIQUE = {
  titleAdd: 'Ajouter un compte analytique',
  titleEdit: 'Modifier un compte analytique',
  informationCompteAnalytique: {
    compteAnalytique: 'Compte analytique',
  },
  success: {
    add: 'Le compte analytique a été ajouté avec succès.',
    edit: 'Le compte analytique a été modifié avec succès.',
  },
  error: {
    compteAnalytique: 'Compte analytique',
  },
};
